<template>
    <div class="row main-content">
        <div class="col-md-2 ">
            <sidebar>My Tools</sidebar>

        </div>
        <div class="my-tools col-md-10">

            <div>

                <h3>PIP | West Chester Protective Gear Branding and Identity</h3>
                <ul>
                    <li>
                        <figure><!-- PIPwestchesterlogolockupsmall.png -->
                            <img
                                src="/archive/my-tools/PIP-WestChester-Logo-Lockup.png"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select  @change="onChange($event)">
                                <option value="?" style="display:none;">Logos</option>
                                <option value="/archive/my-tools/PIPWestChesterLogoLockups.zip">&bull; Download Logos</option>
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-letterhead.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">Letterhead</option>
                                <option
                                    value="/docs/Letterhead/PIP-West-Chester-Protective-Gear-Letterhead.docx"
                                    >&bull; West Chester Protective Gear Letterhead</option
                                >
                                <option
                                    value="/docs/Letterhead/PIP-West-Chester-Protective-Gear-Internal-Communication-Letterhead.docx"
                                    >&bull; West Chester Protective Gear Internal Communication Letterhead</option
                                >

                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-email-sig.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">Email Signature</option>
                                <option value="/EmailSignature">&bull; Create Your Own</option>

                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-presentation.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Powerpoint</option
                                >
                                <option value="/archive/my-tools/PIP-West-Chester-Lock-Up-Presentation-Template.pptx" >&bull; Preloaded PIP Retail Deck</option>
                                <option value="/archive/my-tools/Official-PowerPoint-PIP-Retail-External.pptx" >&bull; Official PowerPoint PIP Retail External</option>
                                <option value="/archive/my-tools/Official-PowerPoint-PIP-Retail-Internal.pptx" >&bull; Official PowerPoint PIP Retail Internal</option>
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-wallpaper.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Wallpaper</option
                                >
                                <option value="/archive/my-tools/PIP_Retail_wallpaper_1920x1080_RED.jpg" >&bull; PIP Red 1920x1080</option>
                                <option value="/archive/my-tools/PIP_Retail_wallpaper_1920x1080_BLACK.jpg" >&bull; PIP Black 1920x1080</option>
                                <option value="/archive/my-tools/PIP_Retail_wallpaper_2560x1440_RED.jpg" >&bull; PIP Red 2560x1440</option>
                                <option value="/archive/my-tools/PIP_Retail_wallpaper_2560x1440_BLACK.jpg" >&bull; PIP Black 2560x1440</option>
                            </select>
                        </form>
                    </li>
                </ul>
                <br />
                <br />
                <h3>BRAND LOGOS AND COLLATERAL</h3>
                <ul class="brand">
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/Logo-Boss-Red.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">BOSS</option>
                                <option value="/archive/my-tools/2023_Boss_PowerPoint_Template.pptx">&bull; PowerPoint Template</option>
                                <option value="/docs/Logo/Boss-Logo.zip">&bull; Download BOSS Logos</option>
                                <!-- <option disabled style="color:#999;">Branding</option> -->
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                    <option
                                        value="/docs/Catalogs/Boss/2022-Boss-Catalog-Low-Res.pdf"
                                        >&bull; 2022 Boss Catalog</option
                                    >
                                    <option
                                        value="/docs/Catalogs/Boss/2022-Boss-Product-Line.pdf"
                                        >&bull; 2022 Boss Product Line</option
                                    >
                                    <option
                                        value="/docs/Catalogs/Boss/Consumer-Catalog.pdf"
                                        >&bull; Boss Consumer Catalog</option
                                    >
                                    <option
                                        value="/docs/Catalogs/Boss/Winter-Sport-Catalog.pdf"
                                        >&bull; Boss Winter Sport Catalog</option
                                    >
                                    <option
                                        value="/docs/Catalogs/Boss/2021-Boss®-Disposable-Catalog.pdf"
                                        >&bull; Boss Disposable Catalog</option
                                    >
                                    <option disabled style="color:#999;">--Sell Sheets--</option>
                                    <option
                                        value="https://pipusa.sharepoint.com/:x:/s/WCPG/ERJSL6Sj_xJOlolPfHwBqZEBvuunPzdDDAeSA2psUOzCtA"
                                        >&bull; 2023 Boss Glove Cross Reference</option
                                    >
                                    <option
                                        value="/docs/SellSheets/2021-Boss-Footwear-Cross-Reference.pdf"
                                        >&bull; 2021 Boss Footwear Cross Reference</option
                                    >
                                    <option
                                        value="/docs/SellSheets/2021-Boss-Boots-Brochure.pdf"
                                        >&bull; Boss Boots Brochure</option
                                    >
                                    <option
                                        value="/docs/SellSheets/Boss-Footwear-PPT.pptx"
                                        >&bull; Boss Footwear PPT</option
                                    >

                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/PIP_ProSafetyLogo.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">PIP Pro Safety</option>
                                <option value="/archive/my-tools/PIP_Pro_Safety_Logos.zip">&bull; Download PIP Pro Safety Logos</option>
                                <!-- <option disabled style="color:#999;">Branding</option> -->
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/sw-logo.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">Safety Works</option>
                                <option value="/docs/Logo/Safety-Works-Professional-Logo.zip">&bull; Download Safety Works Logos</option>
                                <!-- <option disabled style="color:#999;">Branding</option> -->
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option
                                    value="/docs/Catalogs/SW/SW-Display-Catalog.pdf"
                                    >&bull; Safety Works Display Catalog</option
                                >
                                <option
                                    value="/docs/Catalogs/SW/SW-Product-Catalog.pdf"
                                    >&bull; Safety Works Product Catalog</option
                                >
                                <option disabled style="color:#999;">--Sell Sheets--</option>
                                <option
                                    value="/docs/SellSheets/10068529-Sell-Sheet.pdf"
                                    >&bull; 10068529-Sell-Sheet</option
                                >
                                <option
                                    value="/docs/SellSheets/SW46001-Sell-Sheet.pdf"
                                    >&bull; SW46001-Sell-Sheet</option
                                >
                                <option
                                    value="/docs/SellSheets/SWX00478-Sell-Sheet.pdf"
                                    >&bull; SWX00478-Sell-Sheet</option
                                >

                                <option
                                    value="/docs/SellSheets/2021-Safety-Works-Cone-Sell-Sheet.pdf"
                                    >&bull; 2021 Safety Works Cone Sell Sheet</option
                                >

                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/mud-logo.png"
                                alt="my-tools-icon"
                                 width="100px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">Mud</option>
                                <option value="/archive/my-tools/2021_Mud_PPT.pptx">&bull; PowerPoint Template</option>
                                <option value="/docs/Logo/Mud-Logo.zip">&bull; Download Mud Logos</option>
                                <!-- <option disabled style="color:#999;">Branding</option> -->
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option value="/archive/my-tools/2021-Mud-Catalog-LR.pdf" >&bull; Mud Garden Gloves Catalog</option>
                                <option value="/archive/my-tools/2022-Mud Catalog-Low-Res.pdf" >&bull; 2022 Mud Catalog</option>
                                <option value="/archive/my-tools/2022-MUD-Product-Line.pdf" >&bull; 2022 Mud Product Line</option>
                                <option value="/archive/my-tools/Mud-Assortment-Catalog-No-Pricing.pdf">&bull; Mud Assortment Catalog</option>
                                <option value="/archive/my-tools/Mud-Assortment-Catalog-No-MSRP.pdf">&bull; Mud Assortment Catalog - No MSRP</option>
                                <option value="/archive/my-tools/Mud-Assortment-Set-Up-Document.xlsx">&bull; Mud Assortment Set Up Document</option>
                                <!-- <option disabled style="color:#999;">Sell Sheets</option> -->

                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/WestCounty-Gardener.jpg"
                                alt="my-tools-icon"
                                 width="130px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">West County Gardener</option>
                                <option value="/docs/Logo/West-County-Gardener-Logo.zip">&bull; Download West County Gardener Logos</option>
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option  value="/docs/Catalogs/2023-West-County-Gardener-Catalog.pdf">&bull; 2023 West County Gardener Catalog</option>

                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/hearos-logo.png"
                                alt="my-tools-icon"
                                width="130px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">Hearos</option>
                                <option value="/docs/Logo/Hearos-Logo.zip">&bull; Download Hearos Logos</option>
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option  value="/docs/2023-Hearos-Catalog.pdf">&bull; 2023 Hearos Catalog</option>
                                <option value="/docs/2023-Hearos-Generic-Proposal-Deck-ppt.pptx">&bull; 2023 Hearos Generic Proposal Deck</option>

                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/smg-logo.png"
                                alt="my-tools-icon"
                                width="130px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">Scotts Miracle-Gro</option>
                                <option value="/archive/my-tools/2022_SMG_PPT.pptx">&bull; PowerPoint Template</option>
                                <option value="/docs/Logo/Scotts-Miracle-Gro-Logo.zip">&bull; Download Scotts Miracle-Gro Logos</option>
                                <!-- <option disabled style="color:#999;">Branding</option> -->
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option  value="/archive/my-tools/SMG-Catalog.pdf">&bull; Scotts and Miracle Gro Catalog</option>
                                <option value="/archive/my-tools/SMG-Assortment-Catalog-No-Pricing.pdf">&bull; SMG Assortment Catalog</option>
                                <option value="/archive/my-tools/SMG-Assortment-Set-Up-Document.xlsx">&bull; SMG Assortment Set Up Document</option>
                                <!-- <option disabled style="color:#999;">Sell Sheets</option>
                                <option value="/docs/"></option> -->
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/cat-logo.png"
                                alt="my-tools-icon"

                                width="100px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">Cat</option>
                                <option value="/archive/my-tools/2022_CAT_PPT.pptx">&bull; PowerPoint Template</option>
                                <option value="/docs/Logo/CAT-Logo.zip">&bull; Download Cat Logos</option>
                                <!-- <option disabled style="color:#999;">Branding</option> -->
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option
                                    value="/docs/Catalogs/CAT/CAT-Catalog.pdf"
                                    >&bull; CAT Catalog</option
                                >
                                <option
                                    value="/archive/my-tools/2023_CAT_Product_Line.pdf"
                                    >&bull; CAT Product Line</option
                                >
                                <!-- <option disabled style="color:#999;">Sell Sheets</option>
                                <option value="/docs/"></option> -->
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/brand-logos/John_Deere_logo.png"
                                alt="my-tools-icon"
                                width="100px"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;">John Deere</option>
                                <option value="/archive/my-tools/JohnDeere_Template.pptx">&bull; PowerPoint Template</option>
                                <option value="/docs/Logo/JohnDeere-Logo.zip">&bull; Download John Deere Logos</option>
                                <!-- <option disabled style="color:#999;">Branding</option> -->
                                <option disabled style="color:#999;">--Collateral (catalogs)--</option>
                                <option value="/docs/Catalogs/JD/JD-Catalog.pdf"
                                    >&bull; John Deere Catalog</option
                                >
                                <!-- <option disabled style="color:#999;">Sell Sheets</option>
                                <option value="/docs/"></option> -->
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/Grippaz-Logo-Black.png"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-Grippaz-Brochure-022022.pdf"
                                    >&bull; Brochure: Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/Grippaz-Extended-Use-Gloves-Brochure.pdf"
                                    >&bull; Brochure: Extended Use Gloves - Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/Grippaz-Industrial-Case-Study.pdf"
                                    >&bull; Industrial Case Study: Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/Grippaz-Infographic.pdf"
                                    >&bull; Infographic: Grippaz</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-Extended-Use-Gloves-Brochure--022022.pdf"
                                    >&bull; Blog: Extended Use Nitrile Gloves - Grippaz</option
                                >
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/ATG_Logo_color.jpg"
                                width="100px"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >ATG</option
                                >
                                <option
                                    value="/archive/my-tools/ATG_Logo_color.jpg"
                                    >&bull; Download ATG Logos</option
                                >
                            </select>
                        </form>
                    </li>

                </ul>
                <br />
                <br />
                <h3>MARKETING DOCUMENTS</h3>
                <ul>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-media-add.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Tradeshow Docs</option
                                >
                                <option
                                    value="/docs/Tradeshow/Follow-Up-Form.pdf"
                                    >&bull; Follow Up Form</option
                                >
                                <option
                                    value="/docs/Tradeshow/Show-Specials-SetUp-Form.pdf"
                                    >&bull; Specials Set Up Form</option
                                >
                                <option
                                    value="/docs/Tradeshow/Tradeshow-Recap-Form.docx"
                                    >&bull; Tradeshow Recap Form</option
                                >
                                <option
                                    value="/docs/Tradeshow/Tradeshow-Order-Form.xlsx"
                                    >&bull; Tradeshow Order Form</option
                                >
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-presentation.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Training</option
                                >
                                <option
                                    value="/docs/Training/Eye-and-Face-Protection.pptx"
                                    >&bull; Eye and Face Protection</option
                                >
                                <option
                                    value="/docs/Training/Fall-Protection.pptx"
                                    >&bull; Fall Protection</option
                                >
                                <option
                                    value="/docs/Training/Gloves-in-the-Grocery.pdf"
                                    >&bull; Gloves in the Grocery</option
                                >
                                <option
                                    value="/docs/Training/Hand-Protection-Basics-GP-Chem.pptx"
                                    >&bull; Hand Protection Basics GP Chem</option
                                >
                                <option
                                    value="/docs/Training/Head-Protection-and-Liners.pptx"
                                    >&bull; Head Protection and Liners</option
                                >
                                <option
                                    value="/docs/Training/Hearing-Protection-Long-Version.pptx"
                                    >&bull; Hearing Protection Long Version</option
                                >
                                <option
                                    value="/docs/Training/High-Visibility-Garments-Cold-and-Heat-Stress.pptx"
                                    >&bull; High Visibility Garments Cold and Heat
                                    Stress</option
                                >
                                <option
                                    value="/docs/Training/Respiratory-Protection-Long-Version.pptx"
                                    >&bull; Respiratory Protection Long Version</option
                                >
                                <option
                                    value="/docs/Training/Sales-Meeting.pptx"
                                    >&bull; Sales Meeting</option
                                >
                            </select>
                        </form>
                    </li>
                </ul>
                <br />
                <br />
                <h3>SALES DOCUMENTS</h3>
                <ul>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-price-list.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Price List</option
                                    ><option value="/docs/PriceList/Puma-Safety-SS25-Price-List.pdf">&bull; 2025 PUMA Price List</option>
                                <option value="/docs/PriceList/HEAROS-Price-Sheet-2024.pdf">&bull; 2024 Hearos Price List</option>
                                <!-- <option value="/docs/PriceList/Hearos-2023-Full-Assortment-Details.xlsx">Hearos 2023 Full Assortment Details</option> -->
                                <!--<option value="/docs/PriceList/CAT-Price-List.pdf">&bull; CAT Price List</option>
                                 <option
                                    value="/docs/PriceList/Consumer-Price-List-Effective-10-11-2019.pdf"
                                    >Consumer Price List</option
                                >
                                <option
                                    value="/docs/PriceList/SMG-Retail-2021-Price-List-5-26-2020.pdf"
                                    >SMG Retail 2021 Price List</option
                                >
                                <option
                                    value="/docs/PriceList/SW-Price-Level-Review-process-10-31-18.docx"
                                    >SW Price Level Review Process</option
                                >
                                <option
                                    value="/docs/PriceList/PIP-IND-Aug-1-2020-LIST.xlsx"
                                    >PIP IND Aug 2020 Price List</option
                                >
                                <option
                                    value="/docs/PriceList/Mud-Retail-2020-Price-List.xlsx"
                                    >Mud Retail Price List</option
                                > -->
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-internal.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Internal Docs</option
                                >

                                <option
                                    value="/docs/InternalDocs/Inventory-forecast-template.xlsx"
                                    >&bull; Inventory Forecast Template</option
                                >
                                <option
                                    value="/docs/InternalDocs/WCPG-Product-Quality-Form.pdf"
                                    >&bull; Product Quality Form</option
                                >

                                <option
                                    value="/docs/InternalDocs/WCPG-Price-Level-Review-process-10-31-18.docx"
                                    >&bull; Price Level Review Process</option
                                >
                            </select>
                        </form>
                    </li>
                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-new-account.gif"
                                alt="my-tools-icon"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >New Account Setup</option
                                >
                                <option
                                    value="/docs/NewAccount/New-Account-Form.pdf"
                                    >&bull; New Account Form</option
                                >
                                <option
                                    value="/docs/NewAccount/New-Account-and-New-Agent-Process.docx"
                                    >&bull; New Account and New Agent Process</option
                                >
                                <option
                                    value="/docs/NewAccount/WEST-CHESTER-Ship-to-Form-Retail-111720.pdf"
                                    >&bull; New Ship-to Form</option
                                >
                                <option
                                    value="/docs/NewAccount/West-Chester-part-of-PIP-family-Credit-Application.pdf"
                                    >&bull; Credit Application Form</option
                                >
                                <option
                                    value="/docs/NewAccount/Credit-Application-Processing.docx"
                                    >&bull; Credit Application Processing</option
                                >
                                <option
                                    value="/docs/NewAccount/RetailCustomerProgram.pdf"
                                    >&bull; Retail Customer Program</option
                                >
                                <option
                                    value="/docs/NewAccount/HearosNewCustomerFormExportHachimaru.pdf"
                                    >&bull; Hearos New Customer Form</option
                                >
                            </select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-calendar.gif"
                                alt="my-tools-icon" width="50"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Calendars</option
                                >
                                <option
                                    value="https://pipusa.sharepoint.com/sites/WCPG/Lists/Retail%20Events%20Calendar/calendar.aspx"
                                    target="_blank"
                                    >&bull; View</option
                                >
                            </select>
                        </form>
                    </li>


                    <li>
                        <figure>
                            <img
                                src=" /images/icons/admin-icon-agent.gif"
                                alt="my-tools-icon" width="50"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >Rep Agent Docs</option
                                >
                                <option
                                    value="/docs/RepAgent/New-Agent-Form.pdf"
                                    >&bull; New Agent Form</option
                                >
                                <option
                                    value="/docs/RepAgent/Safety-Works-Inventory-Forecast-Template.xlsx"
                                    >&bull; Inventory Forecast Template</option
                                >
                                <option
                                    value="/docs/RepAgent/WC-Direct-Deposit-Form.pdf"
                                    >&bull; Direct Deposit Authorization - Independent
                                    Rep</option
                                >
                                <option value="/docs/RepAgent/W-9-2018.pdf"
                                    >&bull; W-9</option
                                >
                            </select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/admin-icon-3sp-online-training.gif"
                                alt="my-tools-icon" width="50" style="border:1px solid #3a3a3a; padding:3px;"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >3SP&trade; Online Training</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Online-Training-Internal-Brochure.pdf"
                                    >&bull; 3SP Online Training Internal Brochure</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Online-Training-Internal-Request-Form.pdf"
                                    >&bull; 3SP Online Training Internal Request Form</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Online-Training-External-Brochure.pdf"
                                    >&bull; 3SP Online Training External Brochure</option
                                >
                                <option value="/archive/my-tools/3SP Online Training - Customer Sign Up Process for Sales.pdf"
                                    >&bull; 3SP Online Training - Customer Sign Up Process for Sales</option
                                >
                                <option
                                    value="/archive/my-tools/3SP Online Training_Self-Serve Participants Spreadsheet.xlsx"
                                    >&bull; Online Training Self-Serve Participants Spreadsheet</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Sales-Training-Deck.pptx"
                                    >&bull; 3SP Sales Training Deck</option
                                >
                            </select>
                        </form>
                    </li>

                    <li>
                        <figure>
                            <img
                                src=" /archive/my-tools/admin-icon-3SP-Assessment.jpg"
                                alt="my-tools-icon" width="50" style="border:1px solid #3a3a3a; padding:3px;"
                            />
                        </figure>
                        <form>
                            <select @change="onChange($event)">
                                <option value="?" style="display:none;"
                                    >3SP&trade; Assessment</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Overview---05152020.pdf"
                                    >&bull; Overview</option
                                >
                                <option
                                    value="/archive/my-tools/3SP-Letter---05152020.pdf"
                                    >&bull; Letter</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-3SP-Sample-Assessment.pdf"
                                    >&bull; Sample Assessment</option
                                >
                                <option value="/archive/my-tools/3SP-Hand-Protection-Assessment---05152020.pdf"
                                    >&bull; Hand Protection Assessment</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-3SP-Eye-Protection-Assessment-Form.pdf"
                                    >&bull; Eye Protection Assessment</option
                                >
                                <option
                                    value="/archive/my-tools/PIP-3SP-PPE-Assessment-Form.pdf"
                                    >&bull; Facility Info Assessment</option
                                >
                            </select>
                        </form>
                    </li>
                </ul>

                <br />
                <br />
                <h3>WEBSITE TOOLS</h3>
                <ul>
                    <li v-if="priceDeviationAdmins.includes(user.id) || user.user_group_id == 9 || user.user_group_id == 10">
                        <router-link :to="{ name: 'PriceWorkflowSubmission' }">
                            <figure>
                                    <img
                                        src=" /images/icons/admin-icon-dev-price-portal.gif"
                                        alt="my-tools-icon"
                                    />
                            </figure>
                            <span>Price Activity Workflow</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link  :to="{ name: 'vector-view' }"  >
                            <figure>
                                <img
                                    src=" /images/icons/admin-icon-upload.gif"
                                    alt="my-tools-icon"
                                />
                            </figure>
                            <span >Vector Viewer</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link  :to="{ name: 'SpecSheetDownload' }"  >
                            <figure>
                                <img
                                    src=" /images/icons/admin-icon-spec-sheet.gif"
                                    alt="my-tools-icon"
                                />
                            </figure>
                            <span >Spec Sheet Portal</span>
                        </router-link>
                    </li>
                </ul>

                <br />
                <br />
                <div v-if="user.user_group_id==8">
                    <h3>WEBSITE ADMIN TOOLS</h3>
                    <ul>
                        <li>
                            <router-link :to="{name: 'search-user'}" >
                                <figure>
                                    <img
                                        src=" /images/my-tools-icons/WCPG-Dash-Icons_0018_Group-19.png"
                                        alt="my-tools-icon"
                                    />
                                </figure>
                                <span >Edit User</span></router-link
                            >
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
h3 {
    text-transform: uppercase;
    font: 16px/1.1 "acumin-pro", Helvetica, Arial, sans-serif;
    margin-bottom: 1rem;
    font-size: 1rem;
    font-weight: 600;
    padding-bottom: 0.3rem;
    border-bottom: dotted 1px #ccc;
}
select {
    font-family: "acumin-pro-condensed", Helvetica, Arial, sans-serif;
    color: #666666;
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    width: 100%;
    background: white;
}
.brand{
    figure{
        padding:0;
        margin:0;
        height:100px;
        display:flex;
        justify-content: center;
        align-items:center;
        img{
            height:auto;
        }

    }
}
</style>
<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({ 
            user: state => state.user,
            priceDeviationAdmins: state => state.priceDeviationAdmins
        })
    },
    methods: {
        onChange(event) {
            window.open(event.target.value);
        }
    }
};
</script>
